export default __webpack_public_path__ + "static/media/spooky_hill_m3.2d90f263.png";